var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import VueI18n from 'vue-i18n';
import moment from 'moment';
import { localize } from 'vee-validate';
import axios from 'axios';
import { container, injectable } from 'tsyringe';
import { Dispatcher } from 'packages/core/events/Dispatcher';
import { TranslationsLoaded } from 'packages/core/events/TranslationsLoaded';
import { getLanguage } from 'packages/utilities/Lang';
import ENV from 'config/env';
import 'moment/locale/fi.js';
import 'moment/locale/de.js';
import { merge } from 'lodash';
var LanguageService = /** @class */ (function () {
    function LanguageService(i18n) {
        this.i18n = i18n;
        this.appType = 'spa';
    }
    LanguageService.prototype.setAppType = function (type) {
        this.appType = type;
    };
    Object.defineProperty(LanguageService.prototype, "currentLanguage", {
        /**
         * Get Language
         */
        get: function () {
            return getLanguage();
        },
        enumerable: false,
        configurable: true
    });
    LanguageService.prototype.setLanguage = function (lang) {
        localStorage.setItem('LANGUAGE', lang);
        this.setLanguageAcrossTheApp();
    };
    LanguageService.prototype.setLanguageAcrossTheApp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        moment.locale(this.currentLanguage);
                        localize(this.currentLanguage);
                        document.documentElement.setAttribute('lang', this.currentLanguage);
                        return [4 /*yield*/, this.loadLanguage(this.currentLanguage)];
                    case 1:
                        _a.sent();
                        this.i18n.locale = this.currentLanguage;
                        if (axios.defaults) {
                            axios.defaults.headers.common['Accept-Language'] = this.currentLanguage;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LanguageService.prototype.loadLanguage = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get(ENV.JOBILLA_API_ROOT + "translations/v2/" + (this.appType ? this.appType + "/" : '') + lang)
                            .then(function (response) {
                            _this.i18n.setLocaleMessage(lang, merge(_this.i18n.getLocaleMessage(lang), response.data));
                        })];
                    case 1:
                        _a.sent();
                        container.resolve(Dispatcher).dispatch(new TranslationsLoaded());
                        return [2 /*return*/];
                }
            });
        });
    };
    var _a;
    LanguageService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof VueI18n !== "undefined" && VueI18n) === "function" ? _a : Object])
    ], LanguageService);
    return LanguageService;
}());
export { LanguageService };
